import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value", "aria-label"]
const _hoisted_3 = {
  key: 1,
  class: "form-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: `input-${_ctx.inputId}`,
          class: "form-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      class: "form-control",
      id: `input-${_ctx.inputId}`,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitValue($event))),
      "aria-label": _ctx.label
    }), null, 16, _hoisted_2),
    (_ctx.helperText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.helperText), 1))
      : _createCommentVNode("", true)
  ], 64))
}